import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import SpinnerLoader from "../../../Layout/SpinnerLoader";
import { AreaCodeError, AreaNameError, DeliveryCharge, DeliveryNote, DeliveryTxt, NormalDelivery, QuickDelivery, Save } from "../../../Constant";
import { addDeliveryCharge, addDeliveryChargeRole, viewDelivery, viewDeliveryRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from 'react-toastify';
import Transparentspinner from "../../Common/Loader/Transparentspinner";

const Delivery = () => {
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getDeliveryData();
    }, []);

    const getDeliveryData = async () => {
        setLoading(true);
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewDelivery : viewDeliveryRole);
        if (data.status === true) {
            setValue('quickDelivery', data?.data[0]?.quick_delivery_charge);
            setValue('quickDelNote', data?.data[0]?.quick_delivery_notes);
            setValue('normalDel', data?.data[0]?.normal_delivery_charge);
            setValue('normalDelNote', data?.data[0]?.normal_delivery_notes);
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }


    const onSubmit = async (data) => {
        setLoading(true);
        const postRequest = { 
            quick_delivery_charge: data.quickDelivery, quick_delivery_notes: data.quickDelNote,
            normal_delivery_charge: data.normalDel, normal_delivery_notes: data.normalDelNote 
        }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? addDeliveryCharge : addDeliveryChargeRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                toast.success(addAreaResponse.data.message);
            } else {
                toast.error(addAreaResponse.data.message)
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}
            <Breadcrumbs mainTitle={DeliveryTxt} parent="Settings" title={DeliveryTxt} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{DeliveryCharge}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="quick-delivery">{QuickDelivery}</Label>
                                <input className="form-control" id="quick-delivery" type="text" {...register('quickDelivery')} />
                                <span className="text-danger">{errors.quickDelivery && AreaNameError}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="delivery-note">{DeliveryNote}</Label>
                                <input className="form-control" id="delivery-note" type="text" {...register('quickDelNote')} />
                                <span className="text-danger">{errors.quickDelNote && AreaCodeError}</span>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="area-name">{NormalDelivery}</Label>
                                <input className="form-control" id="area-name" type="text" {...register('normalDel')} />
                                <span className="text-danger">{errors.normalDel && AreaNameError}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="area_code">{DeliveryNote}</Label>
                                <input className="form-control" id="area_code" type="text" {...register('normalDelNote')} />
                                <span className="text-danger">{errors.normalDelNote && AreaCodeError}</span>
                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}
export default Delivery;